import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import axios from "axios";

Vue.use(VueRouter);

// Layout
import UnAuthLayout from "../views/layouts/unauth-layout.vue";
import AuthLayout from "../views/layouts/auth-layout.vue";

// Static
import HomePage from "../views/home";

// Error Pages
import UnauthorizedPage from "../views/errors/unauthorized.vue";

// Auth
import LoginPage from "../views/auth/login.vue";
import ForgotPasswordPage from "../views/auth/forgot-password.vue";

// Companies
import CompaniesPage from "../views/companies/index.vue";
import CompanyCreatePage from "../views/companies/create.vue";
import CompanyIdPage from "../views/companies/id.vue";

// Users
import UsersPage from "../views/users/index.vue";
import UserCreatePage from "../views/users/create.vue";
import UserIdPage from "../views/users/id.vue";
import ProfilePage from "../views/users/id.vue";
import DeviceResetRequestPage from "../views/users/device-reset-requests.vue";
import LocationResetRequestPage from "../views/users/location-reset-requests.vue";
import UsersUploadPage from "../views/users/upload.vue";

// Positions
import PositionsPage from "../views/positions/index.vue";
import PositionCreatePage from "../views/positions/create.vue";
import PositionIdPage from "../views/positions/id.vue";

// Roles
import RolesPage from "../views/roles/index.vue";
import RoleIdPage from "../views/roles/id.vue";

// Modules
import ModulesPage from "../views/modules/index.vue";
import ModuleCreatePage from "../views/modules/create.vue";
import ModuleIdPage from "../views/modules/id.vue";

// Permissions
import PermissionsPage from "../views/permissions/index.vue";
import PermissionCreatePage from "../views/permissions/create.vue";
import PermissionIdPage from "../views/permissions/id.vue";

// Locations
import LocationsPage from "../views/locations/index.vue";
import LocationCreatePage from "../views/locations/create.vue";
import LocationIdPage from "../views/locations/id.vue";

// Company Stocks
import CompanyStocksPage from "../views/company-stocks/index.vue";
import CompanyStockCreatePage from "../views/company-stocks/create.vue";
import CompanyStockIdPage from "../views/company-stocks/id.vue";

// Stock Logs
import StockLogsPage from "../views/stock_logs/index.vue";
import StockLogCreatePage from "../views/stock_logs/create.vue";
import StockLogIdPage from "../views/stock_logs/id.vue";

// Assigned Stocks
import AssignedStocksPage from "../views/assigned_stocks/index.vue";
import AssignedStockCreatePage from "../views/assigned_stocks/create.vue";
import AssignedStockIdPage from "../views/assigned_stocks/id.vue";
import StockDetailsPage from "../views/assigned_stocks/stock-details.vue";

// Admin Stock Tracking
import AdminStockTrackingPage from "../views/admin-stock-tracking/index.vue";

// Values
import Values from "@/views/values/index.vue";
import ValueCreate from "@/views/values/create.vue";
import ValueId from "@/views/values/id.vue";

// ValueLists
import ValueLists from "@/views/value-lists/index.vue";
import ValueListUpload from "@/views/value-lists/upload.vue";
import ValueListCreate from "@/views/value-lists/create.vue";
import ValueListId from "@/views/value-lists/id.vue";

// User Timestamps
import UserTimestamps from "@/views/user-timestamps/index.vue";

// Banners
import BannersPage from "../views/banners/index.vue";
import BannerCreatePage from "../views/banners/create.vue";
import BannerIdPage from "../views/banners/id.vue";
// Feedback Questions
import FeedbackQuestionsPage from "../views/feedback-questions/index.vue";
// Payment QR
import PaymentQRPage from "../views/payment-qr/index.vue";
// Products
import ProductsPage from "../views/products/index.vue";
import ProductCreatePage from "../views/products/create.vue";
import ProductIdPage from "../views/products/id.vue";
import ProductIDetailsPage from "../views/products/indexlists.vue";
import VariantQRListPage from "../views/products/variant-qr-list.vue";
import QRScannerPage from "../views/products/qr-scanner.vue";
import ScannedProductDetailPage from "../views/products/scanned-detail.vue";
// Public
import PublicVariantDetails from "../views/public/variant-details.vue";
import PrivacyPolicyPage from "../views/public/privacy-policy.vue";
// Categorys
import CategoriesPage from "../views/categories/index.vue";
import CategoryCreatePage from "../views/categories/create.vue";
import CategoryIdPage from "../views/categories/id.vue";
//sub-categories
import SubcategoryPage from "../views/sub-categories/index.vue";
import SubcategoryCreatePage from "../views/sub-categories/create.vue";
import SubcategoryIdPage from "../views/sub-categories/id.vue";
import SubCategoriesListPage from "../views/sub-categories/all.vue";
// //orders
import OrdersPage from "../views/orders/index.vue";
import OrderCreatePage from "../views/orders/create.vue";
import OrderIdPage from "../views/orders/id.vue";
import OrderDetailsPage from "../views/order-details/index.vue";
//Stores
import StoresPage from "../views/stores/index.vue";
import StoreCreatePage from "../views/stores/create.vue";
import StoreIdPage from "../views/stores/id.vue";
//Vendors
import VendorsPage from "../views/vendors/index.vue";
import VendorCreatePage from "../views/vendors/create.vue";
import VendorIdPage from "../views/vendors/id.vue";
//Colors
import ColorsPage from "../views/colors/index.vue";
//PurchaseOrders
import PurchaseOrdersPage from "../views/purchase-orders/index.vue";
import PurchaseOrderCreatePage from "../views/purchase-orders/create.vue";
import PurchaseOrderIdPage from "../views/purchase-orders/id.vue";
import PurchaseOrderViewPage from "../views/purchase-orders/view.vue";
//PurchaseBills
import PurchaseBillsPage from "../views/purchase-bills/index.vue";
import PurchaseBillCreatePage from "../views/purchase-bills/create.vue";
import PurchaseBillIdPage from "../views/purchase-bills/id.vue";
//VendorPayments
import VendorPaymentsPage from "../views/vendor-payments/index.vue";
//Returns
import PurchaseReturnsPage from "../views/purchase-returns/index.vue";
import SaleReturnsPage from "../views/sale-returns/index.vue";
import ReturnStocksPage from "../views/return-stocks/index.vue";
import ReplacementsPage from "../views/replacements/index.vue";
import SaleLinkagePage from "../views/sale-linkage/index.vue";
//StockAssignments
import StockAssignmentsPage from "../views/stock-assignments/index.vue";
import StockAssignmentIdPage from "../views/stock-assignments/id.vue";
//Expenses
import ExpensesPage from "../views/expenses/index.vue";
import ExpenseCreatePage from "../views/expenses/create.vue";
import ExpenseIdPage from "../views/expenses/id.vue";
import ExpenseCategoriesPage from "../views/expense-categories/index.vue";
//Carts
// import CartsPage from "../views/carts/index.vue";
// import CartCreatePage from "../views/carts/create.vue";
// //wishlists
import WishlistsPage from "../views/wishlists/index.vue";
//UserKycDetail
import UsersKYCDetailsPage from "../views/kyc-details/index.vue";
import UsersKYCDetailCreatePage from "../views/kyc-details/create.vue";
import UsersKYCDetailIdPage from "../views/kyc-details/id.vue";
//VehicleKycDocuments
import VehicleKYCDocumentsPage from "../views/vehicle-kyc-documents/index.vue";
//Tickets
import TicketsPage from "../views/tickets/index.vue";
import TicketChatPage from "../views/tickets/chat.vue";
//Notifications
import NotificationsPage from "../views/notifications/index.vue";

// Marketing Campaigns
import MarketingCampaignsPage from "../views/marketing-campaigns/index.vue";
import MarketingCampaignCreatePage from "../views/marketing-campaigns/create.vue";
import MarketingCampaignLogsPage from "../views/marketing-campaigns/logs.vue";
import AccountDeleteRequestsPage from "../views/account-delete-requests/index.vue";
import AccountDeleteRequestCreatePage from "../views/account-delete-requests/create.vue";

const routes = [
  // Root redirect to home
  {
    path: "/",
    redirect: "/home",
  },
  // AuthLayout
  {
    path: "/auth",
    name: "AuthLayout",
    component: AuthLayout,
    children: [
      {
        path: "/home",
        name: "HomePage",
        component: HomePage,
        meta: { permission: "admin-only" },
      },
      // Comapnies
      {
        path: "/companies",
        name: "CompaniesPage",
        component: CompaniesPage,
        meta: { permission: "COMPANIES.VIEW" },
      },
      {
        path: "/companies/create",
        name: "CompanyCreatePage",
        component: CompanyCreatePage,
        meta: { permission: "COMPANIES.CREATE" },
      },
      {
        path: "/companies/:companyId",
        name: "CompanyIdPage",
        component: CompanyIdPage,
        meta: { permission: "COMPANIES.UPDATE" },
      },
      // Users
      {
        path: "/users",
        name: "UsersPage",
        component: UsersPage,
        meta: { permission: "USERS.VIEW" },
      },
      {
        path: "/users/create",
        name: "UserCreatePage",
        component: UserCreatePage,
        meta: { permission: "USERS.CREATE" },
      },
      {
        path: "/users/upload",
        name: "UsersUploadPage",
        component: UsersUploadPage,
        meta: { permission: "USERS.CREATE" },
      },
      {
        path: "/profile/:userId",
        name: "ProfilePage",
        component: ProfilePage,
        meta: { permission: "USERS.SINGLE_VIEW" },
      },
      {
        path: "/users/:userId",
        name: "UserIdPage",
        component: UserIdPage,
        meta: { permission: "USERS.UPDATE" },
      },
      {
        path: "/device-reset-requests",
        name: "DeviceResetRequestPage",
        component: DeviceResetRequestPage,
        meta: { permission: "USERS.VIEW" },
      },
      {
        path: "/location-reset-requests",
        name: "LocationResetRequestPage",
        component: LocationResetRequestPage,
        meta: { permission: "USERS.VIEW" },
      },
      // Locations
      {
        path: "/locations",
        name: "LocationsPage",
        component: LocationsPage,
        meta: { permission: "LOCATIONS.VIEW" },
      },
      {
        path: "/locations/create",
        name: "LocationCreatePage",
        component: LocationCreatePage,
        meta: { permission: "LOCATIONS.CREATE" },
      },
      {
        path: "/locations/:locationId",
        name: "LocationIdPage",
        component: LocationIdPage,
        meta: { permission: "LOCATIONS.UPDATE" },
      },
      // Company Stocks
      {
        path: "/company-stocks",
        name: "CompanyStocksPage",
        component: CompanyStocksPage,
        meta: { permission: "COMPANY_STOCKS.VIEW" },
      },
      {
        path: "/company-stocks/create",
        name: "CompanyStockCreatePage",
        component: CompanyStockCreatePage,
        meta: { permission: "COMPANY_STOCKS.CREATE" },
      },
      {
        path: "/company-stocks/:stockId",
        name: "CompanyStockIdPage",
        component: CompanyStockIdPage,
        meta: { permission: "COMPANY_STOCKS.UPDATE" },
      },
      // Stock Logs
      {
        path: "/stock_logs",
        name: "StockLogsPage",
        component: StockLogsPage,
        meta: { permission: "STOCK_LOGS.VIEW" },
      },
      {
        path: "/stock_logs/create",
        name: "StockLogCreatePage",
        component: StockLogCreatePage,
        meta: { permission: "STOCK_LOGS.CREATE" },
      },
      {
        path: "/stock_logs/:id",
        name: "StockLogIdPage",
        component: StockLogIdPage,
        meta: { permission: "STOCK_LOGS.UPDATE" },
      },
      // Assigned Stocks
      {
        path: "/assigned_stocks",
        name: "AssignedStocksPage",
        component: AssignedStocksPage,
        meta: { permission: "ASSIGNED_STOCKS.VIEW" },
      },
      {
        path: "/assigned_stocks/create",
        name: "AssignedStockCreatePage",
        component: AssignedStockCreatePage,
        meta: { permission: "ASSIGNED_STOCKS.CREATE" },
      },
      {
        path: "/assigned_stocks/stock-details",
        name: "StockDetailsPage",
        component: StockDetailsPage,
        meta: { permission: "ASSIGNED_STOCKS.VIEW" },
      },
      {
        path: "/assigned_stocks/:assignedStockId",
        name: "AssignedStockIdPage",
        component: AssignedStockIdPage,
        meta: { permission: "ASSIGNED_STOCKS.UPDATE" },
      },
      // Admin Stock Tracking
      {
        path: "/admin/stock-tracking",
        name: "AdminStockTrackingPage",
        component: AdminStockTrackingPage,
        meta: { permission: "ADMIN_STOCK_TRACKING.VIEW" },
      },
      // Positions
      {
        path: "/positions",
        name: "PositionsPage",
        component: PositionsPage,
        meta: { permission: "POSITIONS.VIEW" },
      },
      {
        path: "/positions/create",
        name: "PositionCreatePage",
        component: PositionCreatePage,
        meta: { permission: "POSITIONS.CREATE" },
      },
      {
        path: "/positions/:positionId",
        name: "PositionIdPage",
        component: PositionIdPage,
        meta: { permission: "POSITIONS.UPDATE" },
      },
      // Roles
      {
        path: "/roles",
        name: "RolesPage",
        component: RolesPage,
        meta: { permission: "ROLES.VIEW" },
      },
      {
        path: "/roles/:roleId",
        name: "RoleIdPage",
        component: RoleIdPage,
        meta: { permission: "ROLES.UPDATE" },
      },
      // Modules
      {
        path: "/modules",
        name: "ModulesPage",
        component: ModulesPage,
        meta: { permission: "MODULES.VIEW" },
      },
      {
        path: "/modules/create",
        name: "ModuleCreatePage",
        component: ModuleCreatePage,
        meta: { permission: "MODULES.CREATE" },
      },
      {
        path: "/modules/:moduleId",
        name: "ModuleIdPage",
        component: ModuleIdPage,
        meta: { permission: "MODULES.UPDATE" },
      },
      // Permissions
      {
        path: "/permissions",
        name: "PermissionsPage",
        component: PermissionsPage,
        meta: { permission: "PERMISSIONS.VIEW" },
      },
      {
        path: "/permissions/create",
        name: "PermissionCreatePage",
        component: PermissionCreatePage,
        meta: { permission: "PERMISSIONS.CREATE" },
      },
      {
        path: "/permissions/:permissionId",
        name: "PermissionIdPage",
        component: PermissionIdPage,
        meta: { permission: "PERMISSIONS.UPDATE" },
      },
      // Values
      {
        path: "/values",
        name: "Values",
        component: Values,
        meta: { permission: "VALUE_LISTS.VIEW" },
      },
      {
        path: "/values/create",
        name: "ValueCreate",
        component: ValueCreate,
        meta: { permission: "VALUE_LISTS.CREATE" },
      },
      {
        path: "/values/:valueId",
        name: "ValueId",
        component: ValueId,
        meta: { permission: "VALUE_LISTS.UPDATE" },
      },
      // ValueLists
      {
        path: "/value-lists",
        name: "ValueLists",
        component: ValueLists,
        meta: { permission: "VALUE_LISTS.VIEW" },
      },
      {
        path: "/value-lists/upload",
        name: "ValueListUpload",
        component: ValueListUpload,
        meta: { permission: "VALUE_LISTS.CREATE" },
      },
      {
        path: "/value-lists/create",
        name: "ValueListCreate",
        component: ValueListCreate,
        meta: { permission: "VALUE_LISTS.CREATE" },
      },
      {
        path: "/value-lists/:valueListId",
        name: "ValueListId",
        component: ValueListId,
        meta: { permission: "VALUE_LISTS.UPDATE" },
      },
      // UserTimestamps
      {
        path: "/user-timestamps",
        name: "UserTimestamps",
        component: UserTimestamps,
        meta: { permission: "USERS.VIEW" },
      },
      // Banners
      {
        path: "/banners",
        name: "BannersPage",
        component: BannersPage,
        meta: { permission: "BANNERS.VIEW" },
      },
      {
        path: "/banners/create",
        name: "BannerCreatePage",
        component: BannerCreatePage,
        meta: { permission: "BANNERS.CREATE" },
      },
      {
        path: "/banners/:bannerId",
        name: "BannerIdPage",
        component: BannerIdPage,
        meta: { permission: "BANNERS.UPDATE" },
      },
      // Feedback Questions
      {
        path: "/feedback-questions",
        name: "FeedbackQuestionsPage",
        component: FeedbackQuestionsPage,
        meta: { permission: "ADMIN" },
      },
      // Payment QR
      {
        path: "/payment-qr",
        name: "PaymentQRPage",
        component: PaymentQRPage,
        meta: { permission: "ADMIN" },
      },
      // Products
      {
        path: "/products",
        name: "ProductsPage",
        component: ProductsPage,
        meta: { permission: "PRODUCTS.VIEW" },
      },
      {
        path: "/products/create",
        name: "ProductCreatePage",
        component: ProductCreatePage,
        meta: { permission: "PRODUCTS.CREATE" },
      },
      {
        path: "/products/:productId",
        name: "ProductIdPage",
        component: ProductIdPage,
        meta: { permission: "PRODUCTS.UPDATE" },
      },
      {
        path: "/products/:productId/productDetails",
        name: "ProductIDetailsPage",
        component: ProductIDetailsPage,
        meta: { permission: "PRODUCTS.SINGLE_VIEW" },
      },
      {
        path: "/products/:productId/qr-codes",
        name: "VariantQRListPage",
        component: VariantQRListPage,
        meta: { permission: "PRODUCTS.VIEW" },
      },
      {
        path: "/qr-scanner",
        name: "QRScanner",
        component: QRScannerPage,
        meta: { requiresAuth: true },
      },
      {
        path: "/scanned-product/:qrCode",
        name: "ScannedProductDetail",
        component: ScannedProductDetailPage,
        meta: { requiresAuth: true },
      },
      // Categorys
      {
        path: "/categories",
        name: "CategoriesPage",
        component: CategoriesPage,
        meta: { permission: "CATEGORIES.VIEW" },
      },
      {
        path: "/categories/create",
        name: "CategoryCreatePage",
        component: CategoryCreatePage,
        meta: { permission: "CATEGORIES.CREATE" },
      },
      {
        path: "/categories/:categoryId",
        name: "CategoryIdPage",
        component: CategoryIdPage,
        meta: { permission: "CATEGORIES.UPDATE" },
      },
      //sub-categories
      {
        path: "/sub-categories",
        name: "SubCategoriesListPage",
        component: SubCategoriesListPage,
        meta: { permission: "CATEGORIES.VIEW" },
      },
      {
        path: "/categories/:categoryId/sub-categories",
        name: "SubcategoryPage",
        component: SubcategoryPage,
        meta: { permission: "CATEGORIES.VIEW" },
      },
      {
        path: "/categories/:categoryId/sub-categories/create",
        name: "SubCategoryCreatePage",
        component: SubcategoryCreatePage,
        meta: { permission: "CATEGORIES.CREATE" },
      },
      {
        path: "/categories/:categoryId/sub-categories/:subcategoryId",
        name: "SubcategoryIdPage",
        component: SubcategoryIdPage,
        meta: { permission: "CATEGORIES.UPDATE" },
      },
      // //orders
      {
        path: "/orders",
        name: "OrdersPage",
        component: OrdersPage,
        meta: { permission: "ORDERS.VIEW" },
      },
      {
        path: "/orders/create",
        name: "OrderCreatePage",
        component: OrderCreatePage,
        meta: { permission: "ORDERS.CREATE" },
      },
      {
        path: "/orders/:orderId",
        name: "OrderIdPage",
        component: OrderIdPage,
        meta: { permission: "ORDERS.UPDATE" },
      },
      // OrderDetails
      {
        path: "/orders/:orderId/order-details",
        name: "OrderDetailsPage",
        component: OrderDetailsPage,
        meta: { permission: "ORDERS.SINGLE_VIEW" },
      },
      // Stores
      {
        path: "/stores",
        name: "StoresPage",
        component: StoresPage,
        meta: { permission: "STORES.VIEW" },
      },
      {
        path: "/stores/create",
        name: "StoreCreatePage",
        component: StoreCreatePage,
        meta: { permission: "STORES.CREATE" },
      },
      {
        path: "/stores/:id",
        name: "StoreIdPage",
        component: StoreIdPage,
        meta: { permission: "STORES.UPDATE" },
      },
      // Vendors
      {
        path: "/vendors",
        name: "VendorsPage",
        component: VendorsPage,
        meta: { permission: "VENDORS.VIEW" },
      },
      {
        path: "/vendors/create",
        name: "VendorCreatePage",
        component: VendorCreatePage,
        meta: { permission: "VENDORS.CREATE" },
      },
      {
        path: "/vendors/:id",
        name: "VendorIdPage",
        component: VendorIdPage,
        meta: { permission: "VENDORS.UPDATE" },
      },
      // Colors (Master) - stored as the COLORS value list
      {
        path: "/colors",
        name: "ColorsPage",
        component: ColorsPage,
        meta: { permission: "VALUE_LISTS.VIEW" },
      },
      // Purchase Orders
      {
        path: "/purchase-orders",
        name: "PurchaseOrdersPage",
        component: PurchaseOrdersPage,
        meta: { permission: "PURCHASE_ORDERS.VIEW" },
      },
      {
        path: "/purchase-orders/create",
        name: "PurchaseOrderCreatePage",
        component: PurchaseOrderCreatePage,
        meta: { permission: "PURCHASE_ORDERS.CREATE" },
      },
      {
        path: "/purchase-orders/:id/view",
        name: "PurchaseOrderViewPage",
        component: PurchaseOrderViewPage,
        meta: { permission: "PURCHASE_ORDERS.VIEW" },
      },
      {
        path: "/purchase-orders/:id",
        name: "PurchaseOrderIdPage",
        component: PurchaseOrderIdPage,
        meta: { permission: "PURCHASE_ORDERS.UPDATE" },
      },
      // Purchase Bills
      {
        path: "/purchase-bills",
        name: "PurchaseBillsPage",
        component: PurchaseBillsPage,
        meta: { permission: "PURCHASE_BILLS.VIEW" },
      },
      {
        path: "/purchase-bills/create",
        name: "PurchaseBillCreatePage",
        component: PurchaseBillCreatePage,
        meta: { permission: "PURCHASE_BILLS.CREATE" },
      },
      {
        path: "/purchase-bills/:id",
        name: "PurchaseBillIdPage",
        component: PurchaseBillIdPage,
        meta: { permission: "PURCHASE_BILLS.UPDATE" },
      },
      // Vendor Payments
      {
        path: "/vendor-payments",
        name: "VendorPaymentsPage",
        component: VendorPaymentsPage,
        meta: { permission: "VENDOR_PAYMENTS.VIEW" },
      },
      // Purchase Returns (goods sent back to vendors)
      {
        path: "/purchase-returns",
        name: "PurchaseReturnsPage",
        component: PurchaseReturnsPage,
        meta: { permission: "PURCHASE_RETURNS.VIEW" },
      },
      // Sale Returns (customer app requests + sales app / counter returns)
      {
        path: "/sale-returns",
        name: "SaleReturnsPage",
        component: SaleReturnsPage,
        meta: { permission: "SALE_RETURNS.VIEW" },
      },
      // Return Stock (goods back through purchase / sale returns, per variant)
      {
        path: "/return-stocks",
        name: "ReturnStocksPage",
        component: ReturnStocksPage,
        meta: { permission: "RETURN_STOCKS.VIEW" },
      },
      // Replacements (same product, same / other size, within 48h of delivery)
      {
        path: "/replacements",
        name: "ReplacementsPage",
        component: ReplacementsPage,
        meta: { permission: "REPLACEMENTS.VIEW" },
      },
      // Sale Linkage (each sale with its replacements and returns)
      {
        path: "/sale-linkage",
        name: "SaleLinkagePage",
        component: SaleLinkagePage,
        meta: { permission: "SALE_LINKAGE.VIEW" },
      },
      // Stock Assignments (loan invoice + installment payments for assigned stock)
      {
        path: "/stock-assignments",
        name: "StockAssignmentsPage",
        component: StockAssignmentsPage,
        meta: { permission: "STOCK_ASSIGNMENTS.VIEW" },
      },
      {
        path: "/stock-assignments/:id",
        name: "StockAssignmentIdPage",
        component: StockAssignmentIdPage,
        meta: { permission: "STOCK_ASSIGNMENTS.VIEW" },
      },
      // Expenses
      {
        path: "/expenses",
        name: "ExpensesPage",
        component: ExpensesPage,
        meta: { permission: "EXPENSES.VIEW" },
      },
      {
        path: "/expenses/create",
        name: "ExpenseCreatePage",
        component: ExpenseCreatePage,
        meta: { permission: "EXPENSES.CREATE" },
      },
      {
        path: "/expenses/:id",
        name: "ExpenseIdPage",
        component: ExpenseIdPage,
        meta: { permission: "EXPENSES.UPDATE" },
      },
      // Expense Categories
      {
        path: "/expense-categories",
        name: "ExpenseCategoriesPage",
        component: ExpenseCategoriesPage,
        meta: { permission: "EXPENSE_CATEGORIES.VIEW" },
      },
      //carts
      // {
      //   path: "/carts",
      //   name: "prodCartsPageuctsPage",
      //   component: CartsPage,
      //   meta: { permission: "CARTS.VIEW" },
      // },
      // {
      //   path: "/carts/create",
      //   name: "CartCreatePage",
      //   component: CartCreatePage,
      //   meta: { permission: "CARTS.CREATE" },
      // },
      //wishlists
      {
        path: "/wishlists",
        name: "WishlistsPage",
        component: WishlistsPage,
        meta: { permission: "WISHLISTS.VIEW" },
      },
      //KYC Details
      {
        path: "/user-kyc-details/create",
        name: "UsersKYCDetailCreatePage",
        component: UsersKYCDetailCreatePage,
        meta: { permission: "USERS.CREATE" },
      },
      {
        path: "/user-kyc-details/:userDetailId",
        name: "UsersKYCDetailIdPage",
        component: UsersKYCDetailIdPage,
        meta: { permission: "USERS.UPDATE" },
      },
      {
        path: "/users/:userId/user-kyc-details",
        name: "UsersKYCDetailsPage",
        component: UsersKYCDetailsPage,
        meta: { permission: "USERS.VIEW" },
      },
      //Vehicle KYC Documents
      {
        path: "/vehicle-kyc-documents",
        name: "VehicleKYCDocumentsPage",
        component: VehicleKYCDocumentsPage,
        meta: { permission: "USERS.VIEW" },
      },
      // Analytics - Distributors
      {
        path: "/analytics/distributors",
        name: "DistributorAnalyticsPage",
        component: () => import("../views/analytics/distributors/index.vue"),
        meta: { permission: "DASHBOARD.VIEW" },
      },
      {
        path: "/analytics/distributors/:distributorId",
        name: "DistributorDetailsPage",
        component: () => import("../views/analytics/distributors/details.vue"),
        meta: { permission: "DASHBOARD.VIEW" },
      },
      // Analytics - Franchises
      {
        path: "/analytics/franchises",
        name: "FranchiseAnalyticsPage",
        component: () => import("../views/analytics/franchises/index.vue"),
        meta: { permission: "DASHBOARD.VIEW" },
      },
      {
        path: "/analytics/franchises/:franchiseId",
        name: "FranchiseDetailsPage",
        component: () => import("../views/analytics/franchises/details.vue"),
        meta: { permission: "DASHBOARD.VIEW" },
      },
      // Analytics - Sales Executive
      {
        path: "/analytics/sale-executives",
        name: "SaleExecutiveAnalyticsPage",
        component: () => import("../views/analytics/sale-executives/index.vue"),
        meta: { permission: "DASHBOARD.VIEW" },
      },
      {
        path: "/analytics/sale-executives/:saleExecutiveId",
        name: "SaleExecutiveDetailsPage",
        component: () => import("../views/analytics/sale-executives/details.vue"),
        meta: { permission: "DASHBOARD.VIEW" },
      },
      // Analytics - Global Dashboard
      {
        path: "/analytics/global-dashboard",
        name: "GlobalDashboardPage",
        component: () =>
          import("../views/analytics/global-dashboard/index.vue"),
        meta: { permission: "GLOBAL_DASHBOARD.VIEW" },
      },
      // Transporter Manager Dashboard
      {
        path: "/transporter-manager/dashboard",
        name: "TransporterManagerDashboard",
        component: () =>
          import("../views/transporter-manager/dashboard.vue"),
        // No permission check needed - backend validates TRANSPORTER MANAGER position
      },
      // Franchise Stock Management
      {
        path: "/franchise-stocks",
        name: "FranchiseStocksPage",
        component: () => import("../views/franchise-stocks/index.vue"),
        meta: { permission: "ASSIGNED_STOCKS.VIEW" },
      },
      // Sales & Stock Management
      {
        path: "/sales-stock-management",
        name: "SalesStockManagementPage",
        component: () => import("../views/sales-stock-management/index.vue"),
        meta: { permission: "ORDERS.VIEW" },
      },
      // Reporting
      {
        path: "/reporting",
        name: "ReportingPage",
        component: () => import("../views/reporting/index.vue"),
        meta: { permission: "ORDERS.VIEW" },
      },
      // Accounting
      {
        path: "/accounting",
        name: "AccountingPage",
        component: () => import("../views/accounting/index.vue"),
        meta: { permission: "ORDERS.VIEW" },
      },
      //Tickets
      {
        path: "/tickets",
        name: "TicketsPage",
        component: TicketsPage,
        meta: { permission: "TICKETS.VIEW" },
      },
      {
        path: "/tickets/:id/chat",
        name: "TicketChatPage",
        component: TicketChatPage,
        meta: { permission: "TICKETS.VIEW" },
      },
      //Notifications
      {
        path: "/notifications",
        name: "NotificationsPage",
        component: NotificationsPage,
        meta: { permission: "NOTIFICATIONS.VIEW" },
      },
      // Marketing Campaigns
      {
        path: "/marketing-campaigns",
        name: "MarketingCampaignsPage",
        component: MarketingCampaignsPage,
        meta: { permission: "MARKETING_CAMPAIGNS.VIEW" },
      },
      {
        path: "/marketing-campaigns/create",
        name: "MarketingCampaignCreatePage",
        component: MarketingCampaignCreatePage,
        meta: { permission: "MARKETING_CAMPAIGNS.CREATE" },
      },
      {
        path: "/marketing-campaigns/:campaignId/logs",
        name: "MarketingCampaignLogsPage",
        component: MarketingCampaignLogsPage,
        meta: { permission: "MARKETING_CAMPAIGNS.VIEW" },
      },
      {
        path: "/marketing-campaigns/:campaignId",
        name: "MarketingCampaignEditPage",
        component: MarketingCampaignCreatePage,
        meta: { permission: "MARKETING_CAMPAIGNS.UPDATE" },
      },
      {
        path: "/account-delete-requests",
        name: "AccountDeleteRequestsPage",
        component: AccountDeleteRequestsPage,
      },
    ],
  },
  // End AuthLayout

  // UnAuthLayout
  {
    path: "/unauth",
    name: "UnAuthLayout",
    component: UnAuthLayout,
    children: [
      {
        path: "/login",
        name: "LoginPage",
        component: LoginPage,
      },
      {
        path: "/forgot-password",
        name: "ForgotPasswordPage",
        component: ForgotPasswordPage,
      },
    ],
  },
  //End UnAuthLayout

  // Standalone Error Pages (No Layout)
  {
    path: "/unauthorized",
    name: "UnauthorizedPage",
    component: UnauthorizedPage,
    meta: { standalone: true },
  },

  // Public Routes (No Authentication Required)
  {
    path: "/variant/:variantId",
    name: "PublicVariantDetails",
    component: PublicVariantDetails,
    meta: { public: true },
  },
  {
    path: "/account-delete-requests/create",
    name: "AccountDeleteRequestCreatePage",
    component: AccountDeleteRequestCreatePage,
    meta: { public: true },
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicyPage",
    component: PrivacyPolicyPage,
    meta: { public: true },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

/**
 * ROUTE PERMISSION SYSTEM
 *
 * How to protect routes with permissions:
 *
 * 1. Add a `meta` field with `permission` property to the route:
 *    {
 *      path: "/products",
 *      name: "ProductsPage",
 *      component: ProductsPage,
 *      meta: { permission: "PRODUCTS.VIEW" }  // <-- Permission required
 *    }
 *
 * 2. Permission format: "MODULE.PERMISSION"
 *    - MODULE: PRODUCTS, USERS, ORDERS, CATEGORIES, etc.
 *    - PERMISSION: VIEW (list page), SINGLE_VIEW (detail page), CREATE, UPDATE, DELETE, MASTERS
 *
 * 3. SUPER ADMIN and ADMIN automatically bypass all permission checks
 *
 * 4. Other users need the specific permission in their permissions array
 *
 * 5. If a user tries to access a route without permission, they are redirected to HomePage
 *
 * Examples:
 * - meta: { permission: "PRODUCTS.VIEW" }        // View products list
 * - meta: { permission: "PRODUCTS.CREATE" }      // Create new product
 * - meta: { permission: "PRODUCTS.SINGLE_VIEW" } // View single product details
 * - meta: { permission: "USERS.UPDATE" }         // Edit user
 * - meta: { permission: "ORDERS.DELETE" }        // Delete order
 */

/**
 * Check if user has permission to access route
 * @param {string} permission - Required permission
 * @returns {boolean}
 */
function canAccessRoute(permission) {
  if (!permission) return true; // No permission required

  const user = store.state.auth.user;
  const permissions = store.state.auth.permissions;

  // SUPER ADMIN and ADMIN bypass all permission checks
  if (user && user.roles && user.roles.length > 0) {
    const roleName = user.roles[0].name;
    if (roleName === "SUPER ADMIN" || roleName === "ADMIN") {
      return true;
    }
  }

  // Check if permission exists in user's permissions array
  return permissions && permissions.includes(permission);
}

/**
 * Get default landing page based on user permissions
 * @returns {string} Route name to redirect to
 */
function getDefaultRoute() {
  const user = store.state.auth.user;
  const permissions = store.state.auth.permissions;

  // SUPER ADMIN and ADMIN go to HomePage
  if (user && user.roles && user.roles.length > 0) {
    const roleName = user.roles[0].name;
    if (roleName === "SUPER ADMIN" || roleName === "ADMIN") {
      return "HomePage";
    }
  }

  // Permission to route mapping (in order of priority)
  const permissionRouteMap = [
    { permission: "USERS.VIEW", route: "UsersPage" },
    { permission: "ORDERS.VIEW", route: "OrdersPage" },
    { permission: "PRODUCTS.VIEW", route: "ProductsPage" },
    { permission: "CATEGORIES.VIEW", route: "CategoriesPage" },
    { permission: "COMPANY_STOCKS.VIEW", route: "CompanyStocksPage" },
    { permission: "ASSIGNED_STOCKS.VIEW", route: "AssignedStocksPage" },
    { permission: "STOCK_LOGS.VIEW", route: "StockLogsPage" },
    { permission: "STORES.VIEW", route: "StoresPage" },
    { permission: "VENDORS.VIEW", route: "VendorsPage" },
    { permission: "PURCHASE_ORDERS.VIEW", route: "PurchaseOrdersPage" },
    { permission: "PURCHASE_BILLS.VIEW", route: "PurchaseBillsPage" },
    { permission: "VENDOR_PAYMENTS.VIEW", route: "VendorPaymentsPage" },
    { permission: "PURCHASE_RETURNS.VIEW", route: "PurchaseReturnsPage" },
    { permission: "SALE_RETURNS.VIEW", route: "SaleReturnsPage" },
    { permission: "RETURN_STOCKS.VIEW", route: "ReturnStocksPage" },
    { permission: "REPLACEMENTS.VIEW", route: "ReplacementsPage" },
    { permission: "SALE_LINKAGE.VIEW", route: "SaleLinkagePage" },
    { permission: "LOCATIONS.VIEW", route: "LocationsPage" },
    { permission: "TICKETS.VIEW", route: "TicketsPage" },
    { permission: "BANNERS.VIEW", route: "BannersPage" },
    { permission: "MODULES.VIEW", route: "ModulesPage" },
    { permission: "PERMISSIONS.VIEW", route: "PermissionsPage" },
    { permission: "POSITIONS.VIEW", route: "PositionsPage" },
    { permission: "VALUE_LISTS.VIEW", route: "ValueListsPage" },
  ];

  // Find first permission user has and return corresponding route
  for (const mapping of permissionRouteMap) {
    if (permissions && permissions.includes(mapping.permission)) {
      return mapping.route;
    }
  }

  // If user has no permissions at all, show unauthorized page
  console.log("User has no permissions, redirecting to unauthorized page");
  return "UnauthorizedPage";
}

router.beforeEach((to, from, next) => {
  // Allow public routes without authentication
  if (to.meta && to.meta.public) {
    return next();
  }

  // Allow standalone routes (like UnauthorizedPage) for authenticated users
  if (to.meta && to.meta.standalone && store.getters["auth/authenticated"]) {
    return next();
  }

  if (store.getters["auth/authenticated"] && from.name) {
    to.params.startTime = new Date();
  }
  if (
    to.name === "LoginPage" ||
    to.name === "RegisterPage" ||
    to.name === "ForgotPasswordPage" ||
    to.name === "PublicVariantDetails"
  ) {
    if (store.getters["auth/authenticated"]) {
      // Redirect to appropriate page based on permissions
      const defaultRoute = getDefaultRoute();
      return next({
        name: defaultRoute,
      });
    }
    next();
  } else if (!store.getters["auth/authenticated"]) {
    return next({
      name: "LoginPage",
    });
  } else if (to.name === null) {
    const defaultRoute = getDefaultRoute();
    return next({
      name: defaultRoute,
    });
  } else if (to.name === "HomePage") {
    // Check if user can access HomePage (admin-only)
    const user = store.state.auth.user;
    const isAdmin =
      user &&
      user.roles &&
      user.roles.length > 0 &&
      (user.roles[0].name === "SUPER ADMIN" || user.roles[0].name === "ADMIN");

    if (!isAdmin) {
      return next({
        name: "UnauthorizedPage",
        query: { from: to.path, reason: "admin-only" },
      });
    }
    next();
  } else {
    // Check permission if route requires it
    if (to.meta && to.meta.permission) {
      if (!canAccessRoute(to.meta.permission)) {
        return next({
          name: "UnauthorizedPage",
          query: { from: to.path, permission: to.meta.permission },
        });
      }
    }
    next();
  }
});

router.afterEach(async (to, from) => {
  if (
    store.getters["auth/authenticated"] &&
    from.name &&
    !to.name.includes("Create") &&
    !to.name.includes("Edit")
  ) {
    let endTime = new Date();
    let startTime = from.params.startTime;
    let timeSpentInSeconds = "0";
    if (startTime) {
      timeSpentInSeconds = (endTime - startTime) / 1000;
    }
    if (timeSpentInSeconds > 1200) {
      timeSpentInSeconds = 1200;
    }
    console.log(
      `Time spent on "${to.name}" route: ${timeSpentInSeconds} seconds`
    );
    let form = {
      from_path: from.path,
      from_name: from.name,
      user_id: store.getters["auth/user"].id,
      timespent: timeSpentInSeconds,
    };
    await axios.post(`/user_timestamps`, form);
  }
});

export default router;
export { getDefaultRoute };
